import React, { useEffect, useState } from "react";
import NoPage from "./screens/NoPage";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LoginForm from "./screens/Login";
import SignUpForm from "./screens/SignUp";
import ForgotPasswordForm from "./screens/ForgotPassword";
import LandingPage from "./screens/LandingPage";
import AllRoutes from "./screens/AllRoutes";
import CompleteRoutes from "./screens/CompleteRoutes";
import ReserveSeat from "./screens/ReserveSeat";
import DeleteAccount from "./screens/DeleteAccount";
import MyProfile from "./screens/MyProfile";
import OTPVerification from "./screens/OTPVerfication";
import ResetPassword from "./screens/ResetPassword";
import ContactUs from "./screens/ContactUs";
import UpdatePassword from "./screens/UpdatePassword";
import Wallet from "./screens/Wallet";
import Dashboard from "./screens/Dashboard";
import FAQs from "./screens/FAQs";
import OnRideTopup from "./screens/OnRideTopup";
import TopupOptions from "./screens/TopupOptions";
import OnlineTopup from "./screens/OnlineTopup";
import Reservations from "./screens/Reservations";
import AllFeedbacks from "./screens/AllFeedbacks";
import CalendarReservations from "./screens/CalendarReservations";
import Feedback from "./screens/Feedback";
import ComplaintDetail from "./screens/ComplaintDetail";
import PrivacyPolicy from "./screens/PrivacyPolicy";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Dashboard />,
  },
  {
    path: "/allRoutes",
    element: <AllRoutes />,
  },
  {
    path: "/completeRoutes",
    element: <CompleteRoutes />,
  },
  {
    path: "/reserveSeats",
    element: <ReserveSeat />,
  },
  {
    path: "/deleteAccount",
    element: <DeleteAccount />,
  },
  {
    path: "/myProfile",
    element: <MyProfile />,
  },
  {
    path: "/contactUs",
    element: <ContactUs />,
  },
  {
    path: "/faqs",
    element: <FAQs />,
  },
  {
    path: "/updatePassword",
    element: <UpdatePassword />,
  },
  {
    path: "/wallet",
    element: <Wallet />,
  },
  {
    path: "/onRideTopup",
    element: <OnRideTopup />,
  },
  {
    path: "/topupOptions",
    element: <TopupOptions />,
  },
  {
    path: "/onlineTopup",
    element: <OnlineTopup />,
  },
  {
    path: "/calendar",
    element: <CalendarReservations />,
  },
  {
    path: "/reservations",
    element: <Reservations />,
  },
  {
    path: "/allFeedbacks",
    element: <AllFeedbacks />,
  },
  {
    path: "/feedback",
    element: <Feedback />,
  },
  {
    path: "/complaintDetail",
    element: <ComplaintDetail />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "*",
    element: <NoPage />,
  },
]);

const routerlogin = createBrowserRouter([
  {
    path: "/",
    element: <LoginForm />,
  },
  {
    path: "/login",
    element: <LoginForm />,
  },
  {
    path: "/signup",
    element: <SignUpForm />,
  },
  {
    path: "/forgotPassword",
    element: <ForgotPasswordForm />,
  },
  {
    path: "/verifyotp",
    element: <OTPVerification />,
  },
  {
    path: "/resetPassword",
    element: <ResetPassword />,
  },
  {
    path: "/contactUs",
    element: <ContactUs />,
  },
  {
    path: "/privacy",
    element: <PrivacyPolicy />,
  },
  {
    path: "*",
    element: <NoPage />,
  },
]);

export default function Layout() {
  const [isLogin, setIsLogin] = useState(false);

  useEffect(() => {
    const user = window.localStorage.getItem("user");
    if (user) {
      setIsLogin(true);
    } else {
      setIsLogin(false);
    }
  }, []);

  return (
    <>
      {isLogin ? (
        <>
          <RouterProvider router={router} />
        </>
      ) : (
        <>
          <RouterProvider router={routerlogin} />
        </>
      )}
    </>
  );
}
